import { FC } from "react";
import { BillingPlanMonthProps } from "@/shared/types/BillingPlanMonthProps";
import styles from "./BillingPlanMonth.module.scss";
import { useGetPlansQuery } from "@/features/auth/api/authAPI";
import Spinner from "../Spinner/Spinner";
import { useMe, useCurrentOrganization } from "@/Hooks";
import mixpanel from "@/shared/lib/mixpanel";
import { Check } from "lucide-react";

const soloFeatures = [
  {
    title: "Access all apps videos and screens. Gain clarity",
  },
  {
    title: "Traverse the library with search and find your edge",
  },
  {
    title: "20 new apps weekly. Our team at work for you",
  },
];

const BillingPlanMonth: FC<BillingPlanMonthProps> = ({
  handleSelectPlan,
  isProcessing,
}) => {
  const { me } = useMe();
  const currentOrg = useCurrentOrganization();
  const { data: apiDataPlans } = useGetPlansQuery();

  if (!apiDataPlans || apiDataPlans.length === 0) {
    return (
      <div className={styles.root}>
        <Spinner />
      </div>
    );
  }

  const plan = apiDataPlans[0];
  const {
    recurring_interval,
    recurring_interval_count,
    unit_amount,
    id: priceId,
  } = plan;

  const monthlyPrice = (unit_amount / 100 / recurring_interval_count).toFixed(
    2,
  );

  const onUnlockProClick = () => {
    mixpanel.track("Plan Selected", {
      plan_type: "individual_monthly",
      plan_name: "Individual Monthly Pro", // Or derive from plan data if available
      plan_id: priceId,
      plan_price: parseFloat(monthlyPrice),
      plan_currency: plan.currency, // Assuming USD, or get from plan data
      plan_interval: recurring_interval,
      plan_interval_count: recurring_interval_count,
      // Use props if passed, or fall back to hooks if instantiated here
      user_id: me?.id || null, // or me?.id
      user_email: me?.email || null, // or me?.email
      organization_id: currentOrg?.uuid || null, // or currentOrg?.uuid
    });
    handleSelectPlan(priceId); // Call the original handler
  };

  return (
    <div className={styles.pricingContent}>
      <div className={styles.soloContent}>
        <ul className={styles.featuresList}>
          {soloFeatures.map((feature, index) => (
            <li className={styles.feature} key={index}>
              <Check color="#4ade80" />
              <p>{feature.title}</p>
            </li>
          ))}
        </ul>

        <div className={styles.pricingBox}>
          <div className={styles.price}>
            <span className={styles.priceAmount}>${monthlyPrice}</span>
            <span className={styles.pricePeriod}>/month</span>
          </div>
          <button
            className={styles.unlockButton}
            onClick={onUnlockProClick}
            disabled={isProcessing}
          >
            {isProcessing ? "Processing..." : "Unlock Pro"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingPlanMonth;
